import { render, staticRenderFns } from "./loadingVideo.vue?vue&type=template&id=5051d317&scoped=true"
import script from "./loadingVideo.vue?vue&type=script&lang=js"
export * from "./loadingVideo.vue?vue&type=script&lang=js"
import style0 from "./loadingVideo.vue?vue&type=style&index=0&id=5051d317&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051d317",
  null
  
)

export default component.exports